module.exports = __webpack_public_path__ + "static/media/d0fdaf0c-83b1-45e9-be56-5071e1c58184.1c6ef0bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/d0fdaf0c-83b1-45e9-be56-5071e1c58184.jpg
// module id = 853
// module chunks = 0